import React from 'react';
import LeaderboardMoversBasicIcon from './leaderboard-movers-basic-icon';
import LeaderboardMoversExtendedIcon from './leaderboard-movers-extended-icon';

const LeaderboardCellSort = ({ data, options }) => {
    const renderArrows = (movers) => {
        if (movers < 0 && Math.abs(movers) >= options.threshold) {
            return <LeaderboardMoversExtendedIcon stateIcon={'is-negative'} />;
        }

        if (movers < 0 && Math.abs(movers) < options.threshold) {
            return <LeaderboardMoversBasicIcon stateIcon={'is-negative'} />;
        }

        if (movers > 0 && Math.abs(movers) >= options.threshold) {
            return <LeaderboardMoversExtendedIcon stateIcon={''} />;
        }

        if (movers > 0 && Math.abs(movers) < options.threshold) {
            return <LeaderboardMoversBasicIcon stateIcon={''} />;
        }

        return null;
    };

    const getMovers = (movers) => {
        let moversValue = '-';

        if (!movers || movers === 0) {
            return moversValue;
        }

        if (movers > 0) {
            moversValue = movers;
        }

        if (movers < 0) {
            moversValue = movers.toString().replace('-', '');
        }

        return moversValue;
    };

    return (
        <div className="leaderboard__cell leaderboard__cell--movers">
            <div className="leaderboard__cell-content">
                <div className="leaderboard__cell-content-sort-container">
                    {renderArrows(data.movers)}
                    <span className="leaderboard__cell-content-sort-value">{getMovers(data.movers)}</span>
                </div>
            </div>
        </div>
    );
};

export default LeaderboardCellSort;
